var immat = document.querySelector('input[name="immatriculationVehicule"]');
if (immat && document.getElementById('rechercheParImmat')) {
    var isDeletion = false;

    immat.onkeydown = function(event) {
        isDeletion = event.key === 'Backspace' || event.key === 'Delete';
    }

    immat.oninput = function (event) {
        event.target.value = event.target.value.toUpperCase();
        var value = event.target.value;

        if (isDeletion) {
            return;
        }

        value = value.replace(/^([A-Z]{2})(-|\s)?$/g, "$1-");
        value = value.replace(/^([A-Z]{2})(-|\s)?([0-9]{1,2})(-|\s)?$/g, "$1-$3");
        value = value.replace(/^([A-Z]{2})(-|\s)?([0-9]{3})(-|\s)?$/g, "$1-$3-");
        value = value.replace(/^([A-Z]{2})(-|\s)?([0-9]{3})(-|\s)?([A-Z]{1,2})$/g, "$1-$3-$5");

        event.target.value = value;
    };
}
